import {Resolve} from "@angular/router";
import {Subscription} from "rxjs";
import {ProjectsService} from "@components/projects/projects.service";
import {Injectable} from "@angular/core";

@Injectable()
export class ActiveSprintResolver implements Resolve<any> {

    userProject: Subscription;

    constructor(private projectsService: ProjectsService) {
    }

    resolve() {
        // Here is a mock promise which gets 2 seconds
        let result = null;
        this.userProject = this.projectsService.userActiveProject.subscribe(project => {
            if (project != null) {
                result = project;
            } else {
                result = false;
            }

        });
        return result;
    }
}
